<template>
	<div
		ref="orderable"
		class="orderable"
		data-cy="orderable"
	>
		<draggable
			v-if="renderItems"
			drag-class="orderable__item--moving"
			@update="orderChanged"
		>
			<div
				v-for="(id, index) in selection"
				:key="index + '-' + id"
				:data-id="id"
				:style="`background-image: url(${getMediaThumbnail(id)})`"
				class="orderable__item"
			/>

			<div
				v-for="i in placeholderQuantity"
				:key="i + currentLength"
				class="orderable__item orderable__item--empty"
			/>
		</draggable>
	</div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
	components: {
		draggable,
	},

	props: {
		quantity: {
			type: Number,
			required: false,
			default: null,
		},

		minimumFiles: {
			type: Number,
			required: false,
			default: null,
		},

		maximumFiles: {
			type: Number,
			required: false,
			default: null,
		},

		selection: {
			type: Array,
			required: true,
		},

		medias: {
			type: Array,
			required: true,
		},
	},

	data() {
		return {
			renderItems: true,
		};
	},

	computed: {
		placeholderQuantity() {
			let spaceLeft = 0;

			if (this.quantity) {
				spaceLeft = this.quantity - this.selection.length;
			} else if (!this.quantity && !this.maximumFiles && this.minimumFiles) {
				spaceLeft = this.minimumFiles - this.selection.length;
			} else if (!this.quantity && this.maximumFiles) {
				spaceLeft = this.maximumFiles - this.selection.length;
			} else {
				spaceLeft = 10 - this.selection.length;
			}

			return spaceLeft > 0 ? spaceLeft : 0;
		},

		currentLength() {
			if (this.selection && this.selection.length) {
				return this.selection.length;
			}

			return 0;
		},
	},

	watch: {
		renderItems() {
			if (!this.renderItems) {
				this.$nextTick(() => {
					this.renderItems = true;
				});
			}
		},
	},

	methods: {
		getMediaThumbnail(id) {
			const media = this.medias.find(item => item.id === id);

			return (media && media.thumbnail) ? media.thumbnail : '';
		},

		orderChanged() {
			const { orderable } = this.$refs;
			const items = orderable.getElementsByClassName('orderable__item');
			const newSelection = [];

			for (let i = 0; i < items.length; i += 1) {
				if (items[i].hasAttribute('data-id')) {
					newSelection.push(parseInt(items[i].dataset.id, 10));
				}
			}

			this.$emit('order-changed', newSelection);

			this.renderItems = false;
		},
	},
};
</script>

<style lang="scss" scoped src="./orderable.scss" />
